import { Locale, type LocalizedString } from "../Locale.js";

export const helpExtraAreaPathMap = {
	[Locale.cs]: "chci-skladovou-plochu-navic" as const,
} satisfies LocalizedString;
